const DeliveryNote = {

    // FIELDS
    "receiver_name": "Receiver Name",
    "delivery_date": "Delivery Date",
    "document": "Document",
    "search": "Search",
    "delivered_date": "Delivered Date",
    "item": "Item",
    "rate": "Rate",
    "quantity": "Quantity",
    "unit": "Unit",
    "sub_total": "Sub Total",
    "discount": "Discount",
    "vat": "VAT",
    "total": "Total",

    // PAGE HEADER
    "delivery_note": "Delivery Note",

    // TOOLTIP
    "pod": "POD",

    // ERROR
    "error_delivery_date": "Select Date",
    "error_receiver_name": "Enter Receiver Name",

    // TABLE HEADER
    "table_dn_code": 'DN CODE',
    "table_da_code": "DA CODE",
    "table_booking_date": 'BOOKING DATE',
    "table_delivery_date": "DELIVERY DATE",
    "table_delivered_date": "DELIVERED DATE",
    "table_customer": "CUSTOMER",
    "table_receiver": "RECIEVER",
    "table_status": "STATUS",
}

export default DeliveryNote;